import Path from "../../services/paths";
import CoctRobActions from "../actions/coctrobAction";
import utils from "../common/utils";
import axios from "axios";

class CoctRobMiddleware {
  static postCoctRob(
    selectedCategory,
    selectedBrand,
    selectedSku,
    selectedRegion,
    selectedDemandDriver,
    isValue
  ) {
    // console.log("IS VALUEEEEE", isValue);
    let url = `${Path.POST_COCT_ROB}?`;
    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `category=${element}&`;
      });
    }
    if (Array.isArray(selectedBrand)) {
      selectedBrand.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedSku)) {
      selectedSku.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }
    if (Array.isArray(selectedRegion)) {
      selectedRegion.forEach(element => {
        url += `region=${element}&`;
      });
    }
    if (Array.isArray(selectedDemandDriver)) {
      selectedDemandDriver.forEach(element => {
        url += `demmand_driver_type=${element}&`;
      });
    }
    if (isValue) {
      url += `is_value=${isValue}&`;
    } else {
      url += `is_value=${isValue}&`;
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(CoctRobActions.coctrobRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.error) {
                // console.log("ERROR", res.error);
              } else {
                dispatch(
                    CoctRobActions.coctrobSuccessful(res)
                );
              }
            })
            .catch(error => {
              // console.log("IN CATCH");
              dispatch(CoctRobActions.coctrobFailed(error));
            });
        })
        .catch(error => {
          // console.log("IN CATCH");
          dispatch(CoctRobActions.coctrobFailed(error));
        });
    };
  }
}

export default CoctRobMiddleware;
